export const EMAIL_PATTERN = /^[A-Z0-9._'%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const POSTCODE_PATTERN = /^\d+/i;
export const PHONE_NUMBER = /^\d{1,10}/i;
export const PHONE_CONTACT_FORM_REGEX = /^([+])?[0-9()\-#+\s]*$/;
export const SPECIAL_CHARACTER = /[()!#?^@$%&*+~<>|\-/:;€[\]{}=_\\£¥]/g;
export const CONTAINS_LETTER = /[a-zA-Z]/g;
export const CONTAINS_NUMBER = /\d/g;
export const ALPHANUMERIC = /^[a-zA-Z0-9 ]+$/;
export const ALPHANUMERIC_WITH_DASH = /^[a-zA-Z0-9 -]+$/;
export const CONTAINS_LOWER_CASE = /[a-z]/g;
export const CONTAINS_UPPER_CASE = /[A-Z]/g;
export const SPACES = /\s/g;
export const validationPatterns = {
    EMAIL_PATTERN,
    POSTCODE_PATTERN,
    PHONE_NUMBER,
    PHONE_CONTACT_FORM_REGEX,
    SPECIAL_CHARACTER,
    CONTAINS_LETTER,
    CONTAINS_NUMBER,
    ALPHANUMERIC,
    ALPHANUMERIC_WITH_DASH,
    CONTAINS_LOWER_CASE,
    CONTAINS_UPPER_CASE,
    SPACES,
};
export default validationPatterns;
//# sourceMappingURL=validationPatterns.js.map